export default __webpack_public_path__ + "static/media/warning--accident-area--g7.7f6c0b7f.png";